import { PaddingModes, ButtonSize, FontConfigMap } from './types';

export const fontConfigMap: FontConfigMap = {
  [PaddingModes.legacy]: {
    [ButtonSize.tiny]: {
      mobile: { size: '14px', lineHeight: '1.44em' },
      desktop: { size: '14px', lineHeight: '1.43em' },
    },
    [ButtonSize.small]: {
      mobile: { size: '14px', lineHeight: '1.44em' },
      desktop: { size: '16px', lineHeight: '1.5em' },
    },
    [ButtonSize.medium]: {
      mobile: { size: '14px', lineHeight: '1.44em' },
      desktop: { size: '16px', lineHeight: '1.5em' },
    },
    [ButtonSize.large]: {
      mobile: { size: '20px', lineHeight: '1.5em' },
      desktop: { size: '20px', lineHeight: '1.5em' },
    },
  },
  [PaddingModes.dynamicPaddings]: {
    [ButtonSize.tiny]: {
      mobile: { size: '14px', lineHeight: '1' },
      desktop: { size: '14px', lineHeight: '1' },
    },
    [ButtonSize.small]: {
      mobile: { size: '14px', lineHeight: '1' },
      desktop: { size: '16px', lineHeight: '1' }, // hardcoded lineheight
    },
    [ButtonSize.medium]: {
      mobile: { size: '14px', lineHeight: '1' },
      desktop: { size: '16px', lineHeight: '1' },
    },
    [ButtonSize.large]: {
      mobile: { size: '14px', lineHeight: '1' },
      desktop: { size: '16px', lineHeight: '1' }, // hardcoded lineheight
    },
  },
  [PaddingModes.explicitPaddings]: {
    [ButtonSize.tiny]: {
      mobile: { size: '14px', lineHeight: '1.4288em' },
      desktop: { size: '14px', lineHeight: '1.4288em' },
    },
    [ButtonSize.small]: {
      mobile: { size: '16px', lineHeight: '1.5em' },
      desktop: { size: '16px', lineHeight: '1.5em' },
    },
    [ButtonSize.medium]: {
      mobile: { size: '16px', lineHeight: '1.5em' },
      desktop: { size: '16px', lineHeight: '1.5em' },
    },
    [ButtonSize.large]: {
      mobile: { size: '16px', lineHeight: '1.5em' },
      desktop: { size: '16px', lineHeight: '1.5em' },
    },
  },
};
